import {
    Accordion,
    AccordionDetails,
    Box,
    Grid,
    AccordionSummary,
    Typography,
    Card as MuiCard,
    CardContent,
} from '@material-ui/core'
import React, {useState, useEffect, useContext} from 'react'
import { useDispatch, useSelector } from "react-redux";
import { fetchUnits } from "../../../redux/actions/unitsActions";
import { ExpandMore as ExpandMoreIcon } from "@material-ui/icons";
import { AppStateType } from "../../../redux/reducers";
import { spacing } from "@material-ui/system";
import styled from "styled-components/macro";
import { UnitForm } from "./unit-form/UnitForm"
import { useTranslation } from "react-i18next";
import i18n from 'i18next';
import { fetchA11yStandard } from "../../../redux/actions/a11yStandardActions";
import {AccessibilityUnit} from "../../../models/AccessibilityUnits";
import {RenderFacilities} from "./RenderFacilities";
import {UnitsContext} from "../../../components/contexts/UnitsContext";

const Card = styled(MuiCard)(spacing);

const InfoIcon = styled.img`
    height: 56px;
    width: 56px;
`

const InstructionsBox = styled(Box)`
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    ${(props) => props.theme.breakpoints.down("sm")} {
        display: none;
    }
`

const InstructionWrapper = styled(Grid)`
    ${(props) => props.theme.breakpoints.down("sm")} {
        display: grid;
        & > * {
            display: flex;
        }
    }
    ${(props) => props.theme.breakpoints.up("md")} {
        display: none;
        & > * {
            display: none;
        }
    }
`

export default function A11yUnitsPage() {
    const facilities = useSelector((state: AppStateType) => state.facilitiesReducer.facilities);
    const property: any = useSelector((state: AppStateType) => state.propertyReducer.property)
    const a11yStandard = useSelector((state: AppStateType) => state.a11yStandardReducer.a11yStandard.find((item: any) => {
        return item.key === property.a11y_standard
    }))
    const user: any = useSelector((state: AppStateType) => state.authReducer.user)
    const [unitForm, setUnitForm] = useState(false)
    const { t } = useTranslation();
    const { existingUnitState, chosenUnitState, currentUnitState } = useContext(UnitsContext)
    const [currentUnit, setCurrentUnit] = currentUnitState
    const [existingUnit, setExistingUnit] = existingUnitState
    const [, setChosenUnit] = chosenUnitState

    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(fetchUnits(property.id, user.token))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        dispatch(fetchA11yStandard(user.token))
        dispatch(fetchUnits(property.id, user.token))
    }, [i18n.language])

    const getDefaultItem = () => {
        return {
            type: facilities?.length > 0 ? facilities[0] : '',
            property: property ? property.id : '',
        }
    }
    return (
        <Box height='100%' py={4}>
            <Grid container spacing={2}>
                {unitForm ? null :
                  <InstructionWrapper item xs={12} md={8} lg={7}>
                      <InstructionsBox>
                          <img src="/static/img/icons/newUnitIcon.svg" alt="new unit icon" style={{ width: '108px' }} />
                          <Typography variant="h4" gutterBottom style={{ color: 'rgba(238, 238, 238, 0.3)' }}>
                              {t("questionUnits_addNew")}
                          </Typography>
                      </InstructionsBox>
                  </InstructionWrapper>
                }
                <Grid item xs={12} md={4} lg={3}>
                    <RenderFacilities
                      property={property}
                      setCurrentUnit={setCurrentUnit}
                      setExistingUnit={setExistingUnit}
                      setChosenUnit={setChosenUnit}
                      a11yStandard={a11yStandard}
                    />

                </Grid>
                <Grid item xs={12} md={8} lg={6}>
                    <UnitForm
                      currentUnit={currentUnit ?? getDefaultItem()}
                      existingUnit={existingUnit}
                      setExistingUnit={setExistingUnit}
                    />
                </Grid>
                <Grid item xs={12} md={12} lg={3}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                {t("questionUnits_faq1")}
                            </Typography>
                            <Box mt={4}>
                                <InfoIcon src="/static/img/icons/infoIcon.svg" />
                            </Box>
                            <Box mt={1}>
                                <Typography variant="h6" gutterBottom>
                                    {t("A11yUnitsPageSubTitle")}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography variant="body2" gutterBottom style={{ color: 'rgba(238, 238, 238, 0.5)' }}>
                                    {t("A11yUnitsPageDescription")}
                                </Typography>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    )
}
